/* ==========================================================================
   Warenkorb Drawer — Der Geheimtipp
   Eigenständige Drawer-Logik: Öffnen/Schließen, Warenkorbzeilen, Mengen,
   Upsell, Rabattcodes, Versandfortschritt und Versandinfo-Panel.
   ========================================================================== */

(function () {
  'use strict';

  var configEl = document.querySelector('[data-gt-cd-config]');
  if (!configEl) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var TEXT = cfg.text || {};
  var OPTS = cfg.options || {};
  var LABELS = cfg.labels || {};

  var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
  if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';

  var cartUrl = cfg.cartUrl || '/cart';
  var cartJsUrl = cartUrl + '.js';
  var cartUpdateUrl = cartUrl + '/update.js';
  var cartChangeUrl = cartUrl + '/change.js';
  var cartAddUrl = cartUrl + '/add.js';

  var locale = cfg.locale || 'de';
  if (locale.toLowerCase().indexOf('de') === 0) locale = 'de-AT';

  var currency = cfg.currency || 'EUR';

  var formatter = null;
  try {
    formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2
    });
  } catch (e) {
    formatter = null;
  }

  function money(cents) {
    var value = (Number(cents) || 0) / 100;
    if (formatter) return formatter.format(value);
    return '€ ' + value.toFixed(2).replace('.', ',');
  }

  function fill(template, token, value) {
    if (!template) return '';
    return String(template).split(token).join(value);
  }

  function q(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function show(el, visible) {
    if (!el) return;
    if (visible) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  var CHECK_SVG =
    '<svg viewBox="0 0 14 11" width="14" height="11" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M-.046 6.89l.707-.708 2.95 2.95 9.192-9.193.707.707-9.9 9.9-3.656-3.657z"></path></svg>';

  var CLOSE_SVG =
    '<svg viewBox="0 0 20 20" width="11" height="11" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg>';

  var drawer = q('[data-gt-cd]');
  var linesEl = q('[data-gt-lines]');
  var isCartPage = OPTS.isCartPage === true;
  var internalRequest = false;
  var activeCodes = [];

  /* ------------------------------------------------------- Öffnen/Schließen */

  function lockScroll(on) {
    var root = document.documentElement;
    if (on) {
      root.classList.add('gt-cd-locked');
      document.body.classList.add('gt-cd-locked');
    } else {
      root.classList.remove('gt-cd-locked');
      document.body.classList.remove('gt-cd-locked');
    }
  }

  function isOpen() {
    return !!drawer && drawer.classList.contains('gt-is-open');
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('gt-is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    loadLines();
    refresh(true);
    var closeBtn = q('[data-gt-cd-close]', drawer);
    if (closeBtn) {
      try {
        closeBtn.focus({ preventScroll: true });
      } catch (e) {}
    }
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('gt-is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!shipInfoOpen()) lockScroll(false);
  }

  /* ---------------------------------------------------------------- Rendern */

  function render(cart) {
    if (!cart) return;

    var itemCount = cart.item_count || 0;
    var subtotal = typeof cart.original_total_price === 'number' ? cart.original_total_price : cart.items_subtotal_price || 0;
    var net = cart.total_price || 0;
    var discountTotal = Math.max(0, subtotal - net);

    qa('[data-cart-count]').forEach(function (el) {
      el.textContent = itemCount;
      el.setAttribute('data-cart-count', itemCount);
    });

    qa('[data-gt-count]').forEach(function (el) {
      if (itemCount === 1) el.textContent = TEXT.countOne || '';
      else el.textContent = fill(TEXT.countMany || '', '{anzahl}', itemCount);
    });

    var threshold = Number(cfg.threshold) || 0;
    var shippingCost = Number(cfg.shippingCost) || 0;
    var qualified = itemCount > 0 && threshold > 0 && net >= threshold;
    if (hasShippingDiscount(cart)) qualified = true;

    qa('[data-gt-shipbar]').forEach(function (bar) {
      show(bar, threshold > 0 && itemCount > 0);
      var textEl = q('[data-gt-ship-text]', bar);
      var fillEl = q('[data-gt-ship-bar]', bar);
      if (textEl) {
        if (qualified) {
          textEl.classList.add('is-success');
          textEl.innerHTML = '<span class="gt-cd__ship__check">' + CHECK_SVG + '</span>' + escapeHtml(TEXT.shipSuccess || '');
        } else {
          textEl.classList.remove('is-success');
          var remaining = Math.max(0, threshold - net);
          textEl.innerHTML = fill(escapeHtml(TEXT.shipProgress || ''), '{betrag}', '<strong>' + money(remaining) + '</strong>');
        }
      }
      if (fillEl) {
        var pct = threshold > 0 ? Math.min(100, (net / threshold) * 100) : 100;
        if (qualified) pct = 100;
        if (net > 0 && pct < 3) pct = 3;
        if (net === 0) pct = 0;
        fillEl.style.width = pct + '%';
        fillEl.classList.toggle('is-success', qualified);
      }
    });

    qa('[data-gt-note]').forEach(function (el) {
      show(el, itemCount > 0 && LABELS.noteEnable !== false);
    });

    qa('[data-gt-empty]').forEach(function (el) {
      show(el, itemCount === 0);
    });
    qa('[data-gt-lines]').forEach(function (el) {
      show(el, itemCount > 0);
    });
    qa('[data-gt-foot]').forEach(function (el) {
      show(el, itemCount > 0);
    });

    /* Theme-Warenkorbseite */
    qa('[data-cart-empty]').forEach(function (el) {
      el.classList.toggle('cart--hidden', itemCount > 0);
    });
    qa('[data-cart-bottom]').forEach(function (el) {
      el.classList.toggle('cart--hidden', itemCount === 0);
    });

    if (OPTS.lowStockEnable) {
      qa('[data-gt-lowstock]').forEach(function (el) {
        var stock = parseInt(el.getAttribute('data-gt-inventory'), 10);
        var limit = Number(OPTS.lowStockThreshold) || 3;
        if (!isNaN(stock) && stock > 0 && stock <= limit) {
          el.textContent = fill(TEXT.lowStock || '', '{anzahl}', stock);
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    var cartProductIds = (cart.items || []).map(function (item) {
      return String(item.product_id);
    });

    qa('[data-gt-upsell]').forEach(function (section) {
      var cards = qa('[data-gt-upcard]', section);
      var visible = 0;
      cards.forEach(function (card) {
        var pid = card.getAttribute('data-gt-up-product');
        var hide = OPTS.upsellHideInCart && cartProductIds.indexOf(String(pid)) !== -1;
        show(card, !hide);
        if (!hide) visible++;
      });
      show(section, visible > 0 && (!OPTS.upsellRequireItems || itemCount > 0));
      var sub = q('[data-gt-upsell-sub]', section);
      if (sub) sub.textContent = qualified ? TEXT.upsellSubReached || '' : TEXT.upsellSubBelow || '';
    });

    if (OPTS.discountEnable) {
      qa('[data-gt-discount]').forEach(function (el) {
        show(el, itemCount > 0);
      });
      renderChips(cart);
    }

    qa('[data-gt-summary]').forEach(function (el) {
      show(el, itemCount > 0);
    });

    qa('[data-gt-sum-subtotal]').forEach(function (el) {
      el.textContent = money(subtotal);
    });

    var codeList = discountCodes(cart)
      .filter(function (d) {
        return d.applicable !== false;
      })
      .map(function (d) {
        return d.code;
      });

    activeCodes = codeList.slice();

    /* Automatische Rabatte tragen keinen Code, aber einen Titel — den nehmen
       wir für die Beschriftung, damit die Zeile auch dann etwas aussagt. */
    var autoTitles = (cart.cart_level_discount_applications || [])
      .map(function (d) {
        return d.title;
      })
      .filter(Boolean);

    var discountNames = codeList.length ? codeList : autoTitles;

    qa('[data-gt-sum-discount-row]').forEach(function (row) {
      var hasDiscount = discountTotal > 0;
      show(row, hasDiscount);
      if (!hasDiscount) return;
      var label = q('[data-gt-sum-discount-label]', row);
      var value = q('[data-gt-sum-discount]', row);
      if (label) {
        label.textContent = discountNames.length
          ? (TEXT.summaryDiscount || '') + ' (' + discountNames.join(', ') + ')'
          : TEXT.summaryDiscount || '';
      }
      if (value) value.textContent = '− ' + money(discountTotal);
    });

    /* Hinweis auf die Kassa nur, wenn wirklich kein Rabatt greift —
       weder ein Code noch ein automatischer Rabatt. */
    var hatRabatt = discountTotal > 0 || discountCodes(cart).length > 0;
    qa('[data-gt-nodiscount]').forEach(function (el) {
      show(el, itemCount > 0 && !hatRabatt && OPTS.noDiscountEnable !== false);
    });

    var shippingKnown = threshold > 0 || shippingCost > 0;
    var shipping = qualified || itemCount === 0 ? 0 : shippingCost;

    qa('[data-gt-sum-shipping]').forEach(function (el) {
      if (!shippingKnown) el.textContent = TEXT.shippingAtCheckout || '';
      else el.textContent = shipping === 0 ? TEXT.shippingFree || '' : money(shipping);
    });

    var total = net + (shippingKnown ? shipping : 0);

    qa('[data-gt-sum-total]').forEach(function (el) {
      el.textContent = money(total);
    });
    qa('[data-gt-cta-total]').forEach(function (el) {
      el.textContent = money(total);
    });
  }

  function discountCodes(cart) {
    if (Array.isArray(cart.discount_codes) && cart.discount_codes.length) return cart.discount_codes;
    return (cart.cart_level_discount_applications || []).map(function (d) {
      return { code: d.title, applicable: true, amount: d.total_allocated_amount };
    });
  }

  function hasShippingDiscount(cart) {
    return (cart.cart_level_discount_applications || []).some(function (d) {
      return d.target_type === 'shipping_line';
    });
  }

  function renderChips(cart) {
    var codes = discountCodes(cart);
    var applications = cart.cart_level_discount_applications || [];

    qa('[data-gt-chips]').forEach(function (wrap) {
      wrap.innerHTML = '';
      if (!codes.length) {
        wrap.setAttribute('hidden', '');
        return;
      }
      wrap.removeAttribute('hidden');

      codes.forEach(function (entry) {
        var code = entry.code;
        var chip = document.createElement('span');
        var pending = entry.applicable === false;
        chip.className = 'gt-cd__chip' + (pending ? ' gt-cd__chip--pending' : '');

        var effect = '';
        var match = applications.filter(function (a) {
          return String(a.title).toUpperCase() === String(code).toUpperCase();
        })[0];

        var applicableCount = codes.filter(function (d) {
          return d.applicable !== false;
        }).length;

        if (entry.applicable === false) {
          /* Nur hier ist der Code wirklich offen — die Kassa entscheidet. */
          effect = TEXT.codePending || '';
        } else if (match && match.total_allocated_amount) {
          effect = '− ' + money(match.total_allocated_amount);
        } else if (typeof entry.amount === 'number' && entry.amount > 0) {
          effect = '− ' + money(entry.amount);
        } else if (applicableCount === 1 && cart.total_discount > 0) {
          /* Shopify liefert bei Rabattanwendungen oft keinen Titel zurück.
             Bei genau einem gültigen Code ist die Zuordnung trotzdem eindeutig. */
          effect = '− ' + money(cart.total_discount);
        } else {
          effect = '';
        }

        chip.innerHTML =
          '<span class="gt-cd__chip__icon">' + CHECK_SVG + '</span>' +
          '<span class="gt-cd__chip__code">' + escapeHtml(code) + '</span>' +
          '<span class="gt-cd__chip__effect">' + escapeHtml(effect) + '</span>' +
          '<button type="button" class="gt-cd__chip__remove" data-gt-chip-remove="' + escapeHtml(code) + '" aria-label="' +
          escapeHtml(TEXT.codeRemove || 'Rabatt entfernen') + '">' + CLOSE_SVG + '</button>';

        wrap.appendChild(chip);
      });
    });
  }

  /* ------------------------------------------------------------ Datenabruf */

  function api(url, body) {
    internalRequest = true;
    var options = {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(url, options)
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(
        function (data) {
          internalRequest = false;
          return data;
        },
        function (err) {
          internalRequest = false;
          throw err;
        }
      );
  }

  function getCart() {
    return api(cartJsUrl);
  }

  var refreshTimer = null;

  function refresh(immediate) {
    clearTimeout(refreshTimer);
    return new Promise(function (resolve) {
      refreshTimer = setTimeout(
        function () {
          getCart()
            .then(function (cart) {
              render(cart);
              resolve(cart);
            })
            .catch(function () {
              resolve(null);
            });
        },
        immediate ? 0 : 80
      );
    });
  }

  var linesLoading = false;

  function loadLines() {
    if (!linesEl || linesLoading) return Promise.resolve();
    linesLoading = true;
    internalRequest = true;
    return fetch(rootUrl + '?section_id=api-gt-cart-items', { credentials: 'same-origin' })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-api-content]');
        if (content) linesEl.innerHTML = content.innerHTML;
        linesEl.classList.add('is-loaded');
      })
      .catch(function () {})
      .then(function () {
        linesLoading = false;
        internalRequest = false;
      });
  }

  function afterCartChange(openIt) {
    return loadLines()
      .then(function () {
        return refresh(true);
      })
      .then(function () {
        if (openIt && !isCartPage && OPTS.openOnAdd !== false) openDrawer();
      });
  }

  /* ------------------------------------------------------ Mengen und Zeilen */

  function setBusy(row, on) {
    if (!row) return;
    row.classList.toggle('is-busy', !!on);
  }

  function changeLine(key, quantity, row) {
    setBusy(row, true);
    return api(cartChangeUrl, { id: key, quantity: quantity })
      .catch(function () {
        return null;
      })
      .then(function () {
        return loadLines();
      })
      .then(function () {
        return refresh(true);
      });
  }

  function addVariant(variantId, button) {
    if (button) button.classList.add('is-busy');
    return api(cartAddUrl, { items: [{ id: Number(variantId), quantity: 1 }] })
      .catch(function () {
        return null;
      })
      .then(function () {
        if (button) button.classList.remove('is-busy');
        return loadLines();
      })
      .then(function () {
        return refresh(true);
      });
  }

  /* --------------------------------------------------------- Rabattcodes */

  /* Nur Codes weiterreichen, die der Warenkorb auch anwenden kann. Schickt man
     einen unbrauchbaren Code zusammen mit einem gültigen an /cart/update.js,
     verwirft Shopify den ganzen Satz — dann wird gar nichts mehr abgezogen.
     Der gerade eingegebene Code wird davon nicht erfasst: Er bleibt immer
     erhalten, damit auch Segment-Rabatte die Kassa erreichen. */
  function currentCodes(cart) {
    return discountCodes(cart)
      .filter(function (d) {
        return d.applicable !== false;
      })
      .map(function (d) {
        return String(d.code).toUpperCase();
      });
  }

  function setDiscounts(codes) {
    return api(cartUpdateUrl, { discount: codes.join(',') });
  }

  /* Zweiter, unabhängiger Weg: Shopifys Rabatt-Link setzt das Discount-Cookie,
     das die Kassa auswertet. Läuft im Hintergrund ohne Navigation — der
     Kassa-Button bleibt unangetastet und kann dadurch nicht brechen. */
  function primeDiscountCookie(code) {
    if (!code) return Promise.resolve();
    var url = rootUrl + 'discount/' + encodeURIComponent(String(code).trim());
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual',
      cache: 'no-store'
    }).catch(function () {});
  }

  function showCodeError(message) {
    qa('[data-gt-code-error]').forEach(function (el) {
      if (message) {
        el.textContent = message;
        el.removeAttribute('hidden');
      } else {
        el.textContent = '';
        el.setAttribute('hidden', '');
      }
    });
  }

  function applyCode() {
    var input = q('[data-gt-code-input]');
    if (!input) return;
    var raw = (input.value || '').trim();
    if (!raw) {
      showCodeError(TEXT.codeErrorEmpty || '');
      return;
    }
    var code = raw.toUpperCase().replace(/\s+/g, '');
    showCodeError('');

    getCart()
      .then(function (cart) {
        var codes = currentCodes(cart);
        if (codes.indexOf(code) !== -1) {
          showCodeError(TEXT.codeErrorDuplicate || '');
          input.value = '';
          throw new Error('duplicate');
        }
        codes.push(code);
        return setDiscounts(codes);
      })
      .then(function () {
        /* Der Code bleibt im Warenkorb, egal wie ihn die Cart-API bewertet.
           Ob er greift, entscheidet allein die Kassa. */
        input.value = '';
        showCodeError('');
        return primeDiscountCookie(code);
      })
      .catch(function (err) {
        if (err && err.message === 'duplicate') return;
        showCodeError(TEXT.codeErrorGeneric || '');
      })
      .then(function () {
        return loadLines();
      })
      .then(function () {
        return refresh(true);
      });
  }

  function removeCode(code) {
    getCart()
      .then(function (cart) {
        return setDiscounts(
          currentCodes(cart).filter(function (c) {
            return c !== String(code).toUpperCase();
          })
        );
      })
      .catch(function () {
        showCodeError(TEXT.codeErrorGeneric || '');
      })
      .then(function () {
        return loadLines();
      })
      .then(function () {
        return refresh(true);
      });
  }

  /* ------------------------------------------------------ Versandinfo-Panel */

  function shipInfoOpen() {
    return qa('[data-gt-shipinfo]').some(function (panel) {
      return !panel.hasAttribute('hidden');
    });
  }

  function toggleShipInfo(open) {
    qa('[data-gt-shipinfo]').forEach(function (panel) {
      show(panel, open);
    });
    if (open) lockScroll(true);
    else if (!isOpen()) lockScroll(false);
  }

  /* ---------------------------------------------------------------- Events */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-gt-shipinfo-open]')) {
      event.preventDefault();
      toggleShipInfo(true);
      return;
    }

    if (target.closest('[data-gt-shipinfo-close]')) {
      event.preventDefault();
      toggleShipInfo(false);
      return;
    }

    if (target.closest('[data-gt-cd-close]') || target.closest('[data-gt-underlay]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var toggle = target.closest('[data-drawer-toggle="drawer-cart"]');
    if (toggle && drawer) {
      event.preventDefault();
      event.stopPropagation();
      openDrawer();
      return;
    }

    var addBtn = target.closest('[data-gt-add-variant]');
    if (addBtn) {
      event.preventDefault();
      addVariant(addBtn.getAttribute('data-gt-add-variant'), addBtn);
      return;
    }

    var line = target.closest('[data-gt-line]');
    if (line) {
      var key = line.getAttribute('data-gt-key');
      var input = q('[data-gt-qty]', line);
      var qty = input ? parseInt(input.value, 10) || 0 : 0;

      if (target.closest('[data-gt-remove]')) {
        event.preventDefault();
        changeLine(key, 0, line);
        return;
      }
      if (target.closest('[data-gt-inc]')) {
        event.preventDefault();
        changeLine(key, qty + 1, line);
        return;
      }
      if (target.closest('[data-gt-dec]')) {
        event.preventDefault();
        changeLine(key, Math.max(0, qty - 1), line);
        return;
      }
    }

    if (target.closest('[data-gt-code-apply]')) {
      event.preventDefault();
      applyCode();
      return;
    }

    var chipRemove = target.closest('[data-gt-chip-remove]');
    if (chipRemove) {
      event.preventDefault();
      removeCode(chipRemove.getAttribute('data-gt-chip-remove'));
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-gt-qty')) return;
    var line = input.closest('[data-gt-line]');
    if (!line) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 1;
    changeLine(line.getAttribute('data-gt-key'), qty, line);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      var el = event.target;
      if (el && el.hasAttribute && el.hasAttribute('data-gt-code-input')) {
        event.preventDefault();
        applyCode();
      }
      if (el && el.hasAttribute && el.hasAttribute('data-gt-qty')) {
        event.preventDefault();
        el.blur();
      }
      return;
    }

    if (event.key === 'Escape') {
      if (shipInfoOpen()) {
        event.stopPropagation();
        toggleShipInfo(false);
      } else if (isOpen()) {
        event.stopPropagation();
        closeDrawer();
      }
    }
  }, true);

  document.addEventListener('input', function (event) {
    if (event.target && event.target.hasAttribute && event.target.hasAttribute('data-gt-code-input')) {
      showCodeError('');
    }
  });

  /* ------------------------ Warenkorb-Änderungen des Themes mitbekommen */

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;

  function handleExternalCartRequest(url) {
    if (internalRequest) return;
    if (!url || !CART_RE.test(url)) return;
    var isAdd = ADD_RE.test(url);
    setTimeout(function () {
      afterCartChange(isAdd);
    }, 100);
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      var promise = nativeFetch.apply(this, arguments);
      if (url && CART_RE.test(url) && !internalRequest) {
        promise.then(
          function () {
            handleExternalCartRequest(url);
          },
          function () {}
        );
      }
      return promise;
    };
  }

  if (window.XMLHttpRequest) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__gtUrl = url;
      return nativeOpen.apply(this, arguments);
    };
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      var url = self.__gtUrl || '';
      if (url && CART_RE.test(url)) {
        self.addEventListener('load', function () {
          handleExternalCartRequest(url);
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  /* ------------------------------------------------- Sicherheitsnetz Kassa

     Der Klick auf den Kassa-Button wird NICHT abgefangen — der normale Weg des
     Themes läuft unverändert. Falls danach aber nichts passiert (ein Skript
     verschluckt das Absenden), leitet dieser Wächter nach kurzer Zeit selbst
     zur Kassa weiter, damit niemand im Warenkorb hängen bleibt. */

  var isNavigating = false;

  ['beforeunload', 'pagehide', 'unload'].forEach(function (evt) {
    window.addEventListener(evt, function () {
      isNavigating = true;
    });
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var cta = target.closest('[data-gt-checkout]');
    if (!cta) return;

    /* Im Theme-Editor lässt Shopify den Weg zur Kassa grundsätzlich nicht zu.
       Dort darf das Sicherheitsnetz nicht anspringen. */
    if (window.Shopify && window.Shopify.designMode) return;

    var url = cta.getAttribute('data-gt-checkout-url') || rootUrl + 'checkout';
    isNavigating = false;

    setTimeout(function () {
      if (isNavigating) return;
      if (document.visibilityState === 'hidden') return;
      window.location.href = url;
    }, 1200);
  });

  /* Formular-Fallback: Produktformulare ohne AJAX */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;

    var action = form.getAttribute('action') || '';
    if (ADD_RE.test(action) && !isCartPage) {
      setTimeout(function () {
        afterCartChange(true);
      }, 400);
    }
  });

  /* --------------------------------------------------- Statische Labels */

  function applyLabels(scope) {
    qa('[data-gt-text]', scope).forEach(function (el) {
      var key = el.getAttribute('data-gt-text');
      if (LABELS[key] != null) el.textContent = LABELS[key];
    });
    qa('[data-gt-html]', scope).forEach(function (el) {
      var key = el.getAttribute('data-gt-html');
      if (LABELS[key] != null) el.innerHTML = LABELS[key];
    });
    qa('[data-gt-ph]', scope).forEach(function (el) {
      var key = el.getAttribute('data-gt-ph');
      if (LABELS[key] != null) {
        el.setAttribute('placeholder', LABELS[key]);
        el.setAttribute('aria-label', LABELS[key]);
      }
    });
    qa('[data-gt-href]', scope).forEach(function (el) {
      var key = el.getAttribute('data-gt-href');
      if (LABELS[key]) el.setAttribute('href', LABELS[key]);
    });
    qa('[data-gt-aria]', scope).forEach(function (el) {
      var key = el.getAttribute('data-gt-aria');
      if (LABELS[key] != null) el.setAttribute('aria-label', LABELS[key]);
    });
  }

  /* ------------------------------------------------------------------ Boot */

  function boot() {
    applyLabels(document);
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      loadLines();
    }
    refresh(true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Im Theme-Editor wird die Section neu gerendert — Referenzen erneuern. */
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    var newConfig = event.target.querySelector('[data-gt-cd-config]');
    if (!newConfig) return;
    try {
      var parsed = JSON.parse(newConfig.textContent);
      cfg = parsed;
      TEXT = cfg.text || {};
      OPTS = cfg.options || {};
      LABELS = cfg.labels || {};
    } catch (e) {}
    drawer = q('[data-gt-cd]');
    linesEl = q('[data-gt-lines]');
    boot();
  });

  window.addEventListener('pageshow', function () {
    refresh(true);
  });
})();
